export default __webpack_public_path__ + "static/media/ico-lecturn.c7682514.svg";